import requester from '@/services/requester'
import env from '@/.env.js'
import session from '@/services/authentication/session'

const BACKEND_API_V1_URL = env.endpoint_backend

export default {
    retrieve (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/pictures`, parameters)
    },

    update (parameters) {
        return requester.put(`${BACKEND_API_V1_URL}/pictures`, parameters)
    },

    create (parameters) {
        return requester.post(`${BACKEND_API_V1_URL}/pictures/create`, parameters)
    },

    retrieveById (parameters) {
        return requester.get(`${BACKEND_API_V1_URL}/pictures/${parameters}`, {
            responseType: 'arraybuffer',
            Authorization: 'Bearer ' + session.getToken()
        })
    }
}
